/**
 * @generated SignedSource<<02499094cf4bb40f006284a8b8cddf9a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type KlarnaOnSiteMessage_item$data = {
  readonly displayPrice: ReadonlyArray<{
    readonly convertedAmount: number | null;
  } | null> | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "KlarnaOnSiteMessage_item";
};
export type KlarnaOnSiteMessage_item$key = {
  readonly " $data"?: KlarnaOnSiteMessage_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"KlarnaOnSiteMessage_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isTrade"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "priceBookName"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userCountryCode"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "KlarnaOnSiteMessage_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        },
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        }
      ],
      "concreteType": "ItemDisplayPriceType",
      "kind": "LinkedField",
      "name": "displayPrice",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "currency",
              "value": "USD"
            }
          ],
          "kind": "ScalarField",
          "name": "convertedAmount",
          "storageKey": "convertedAmount(currency:\"USD\")"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "e58df00e26b9af81b4744876dd83e8bb";

export default node;
